// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: require('../../package.json').version + ' --DEV',
  apiUrl: 'https://dev-perkss.azurewebsites.net/', //DEVELOPMENT,
  chatApiUrl: 'https://dev-ask.perkss.ai/',
  PaymentSenseSDK:
    'https://web.e.test.connect.paymentsense.cloud/assets/js/client.js',

  SquareupSDK: 'https://sandbox.web.squarecdn.com/v1/square.js',

  posthogApiKey: 'phc_gizH7AJeLGJG8h5hJMhdFKwjNYYPuTrvWMK8bLmJrs7',
  posthogHost: 'https://eu.i.posthog.com', // or your self-hosted URL

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown ok.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
